import { GET_CASCADE_DROPDOWN_VALUES_FAILURE, GET_CASCADE_DROPDOWN_VALUES_REQUEST, GET_CASCADE_DROPDOWN_VALUES_SUCCESS } from "constants/actionTypes";

const intialState = {
  dynamicState: {},
  loading: false,
  errors: {} // Store errors for each cascade table ID
};

// store the api values for each cascade table ID
const cascadeTableIDApiValues = (state = intialState, action: any) => {
  const { payload } = action;
  switch (action.type) {
    case GET_CASCADE_DROPDOWN_VALUES_REQUEST:
      return {
        ...state,
        loading: true,
        errors: null
      };
    case GET_CASCADE_DROPDOWN_VALUES_SUCCESS:
      return {
        ...state,
        loading: false,
        dynamicState: {
          ...state.dynamicState, // Preserve existing values
          [payload.id]: {
            ...payload.data // Merge new values
          }
        },
        errors: {
          ...state.errors,
          [payload.id]: null // Clear any error for this ID on success
        }
      };
    case GET_CASCADE_DROPDOWN_VALUES_FAILURE:
      return {
        ...state,
        loading: false,
        errors: {
          ...state.errors,
          [payload.id]: action.payload.message // Set error for this specific ID
        }
      };
    default:
      return state;
  }
};

export default cascadeTableIDApiValues;